import logo from '../assets/images/mimarint.png';
const RedProfile = ({ name, job, image1 }) => {
    return (
        <>
            <div className="mocketLogo">
                <img src={logo} alt="Profile Logo" />
            </div>
            <div className="userInfoRedProfileHolder">
                <div className="red-img-holder">
                    <img className='mocketImage' src={image1} alt="Profile 2" />
                </div>
                <div className='nameHolderBlue'>
                    <h1 style={{"fontFamily":"pp-name","fontSize":"28px","wordSpacing":"5px","lineHeight":"30px"}}> {name} </h1>
                    <h4 style={{"fontFamily":"sans-title","margin":"25px 0 0 0","fontSize":"13px","opacity":"0.7"}}> {job}</h4>
                </div>
            </div>
        </>
    )
}

export default RedProfile;